import React from "react";

export const Header = (props) => {
  const data = props.data;

  return (
    <header id="header" className="hero-section">
      <div className="hero-split">
        <div className="container">
          <div className="hero-content">
            <span className="hero-eyebrow">
              {data?.eyebrow ?? "Our Vision"}
            </span>
            <h1 className="hero-title">
              {data?.title ?? "Loading"}
            </h1>
            <p className="hero-lead">
              {data?.paragraph ?? "Loading"}
            </p>
            <a
              href="#contact"
              className="btn btn-custom btn-lg page-scroll hero-cta"
            >
              {data?.cta ?? "Request Demo"}
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};
